module.exports = __webpack_public_path__ + "img/kr-card-top-icon-white-5.4fe3a77.png";